export default __webpack_public_path__ + "static/media/mobile.e34c5fdb.jpg";